import Vue from 'vue'
import moment from 'moment'

const couponTypeMap = {
  TICKET: '机票',
  LUGGAGE: '行李',
  MEALS: '餐食',
  ITINERARY: '行程单',
  VIPHALL: '贵宾厅'
}

Vue.filter('couponType', function (value) {
  if (!value) {
    return '-'
  }

  return couponTypeMap[value] || '-'
})

const usePlatformMap = {
  COMMON: '通用',
  APP: 'APP',
  H5: 'H5',
  NN: '网站'
}

Vue.filter('usePlatform', function (value) {
  if (!value) {
    return '-'
  }

  return usePlatformMap[value] || '-'
})

const couponStatusMap = {
  UNUSED: '未使用',
  USING: '使用中',
  USED: '已使用',
  AP: '申退中',
  REFUND: '已退',
  INVALID: '作废',
  UNGRANTED: '未发放',
  VERIFY: '已审核',
  GRANTED: '已发放',
  EXPIRED: '已过期',
  REFAIL: '退券失败'
}

Vue.filter('couponStatus', function (value) {
  if (!value) {
    return '-'
  }

  return couponStatusMap[value] || '-'
})

Vue.filter('applyFltDates', function (value) {
  if (!value || !value.length) {
    return '-'
  }

  return value.map(item => {
    return `${moment(item.flightStartDate).format('YYYY/MM/DD')}-${moment(item.flightEndDate).format('YYYY/MM/DD')}`
  }).join(', ')
})

Vue.filter('format', function (value) {
  if (!value) {
    return '-'
  }

  return moment(value).format('YYYY-MM-DD')
})
